import { DISCIPLINES } from '../../core/contracts'
import { scoreValue } from '../../core/scoring'
import { useT } from '../../platform/i18n/useT'
import type { Progress } from '../useProgress'
import './screens.css'

/** Крупный Hone Score и разбивка по дисциплинам. Переиспользуется на двух экранах. */
export function ScoreBlock({ progress }: { progress: Progress }) {
  const { t } = useT()
  const { total, byDiscipline } = progress
  const totalValue = scoreValue(total)

  return (
    <>
      <div className="sc__score">
        {totalValue !== null ? (
          <div className={total.status === 'ready' ? 'sc__big' : 'sc__big sc__big--soft'}>
            {totalValue}
          </div>
        ) : (
          <div className="sc__big sc__big--muted">—</div>
        )}
        <div className="sc__side">
          <div className="sc__label sc__label--tight">{t('index.title')}</div>
          {total.status === 'collecting' && (
            <div className="sc__hint">
              {totalValue !== null
                ? t('index.provisional', { n: total.sessionsLeft })
                : t('index.collectingHint', { n: total.sessionsLeft })}
            </div>
          )}
        </div>
      </div>

      <div className="sc__two">
        {DISCIPLINES.map((d) => {
          const s = byDiscipline[d]
          const v = scoreValue(s)
          return (
            <div key={d} className="sc__col">
              <div className="sc__k">{t(`discipline.${d}`)}</div>
              <div className={s.status === 'ready' ? 'sc__v' : 'sc__v sc__v--soft'}>
                {v ?? '—'}
              </div>
              <div className="sc__track">
                <i
                  className={`sc__fill sc__fill--${d}`}
                  style={{ width: v !== null ? `${Math.min(100, v / 1.6)}%` : '0%' }}
                />
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}
